// src/context/SiteConfigContext.js
import { createContext, useContext } from 'react';
import { useQuery } from 'react-query';
import { fetchSiteConfig } from '../services/api';

const SiteConfigContext = createContext(null);

// Reasonable defaults while loading
const DEFAULT_CONFIG = {
  brand_name_fa: 'کیوت کندل',
  brand_name_en: 'Cute Candels',
  tagline_fa: 'جایی که هر شمع یک داستان عاشقانه است',
  tagline_en: 'Where every candle tells a love story',
  hero_subtitle_fa: 'شمع‌های گل‌دار دست‌ساز با رایحه‌های طبیعی',
  hero_subtitle_en: 'Handmade floral candles with natural fragrances',
  stat_orders_value: '+500',
  stat_orders_label_fa: 'سفارش موفق',
  stat_orders_label_en: 'Successful Orders',
  stat_satisfaction_value: '100%',
  stat_satisfaction_label_fa: 'رضایت مشتری',
  stat_satisfaction_label_en: 'Customer Satisfaction',
  stat_delivery_value: '1-2 هفته',
  stat_delivery_label_fa: 'زمان تحویل',
  stat_delivery_label_en: 'Delivery Time',
  about_title_fa: 'هر شمع یک اثر هنری است',
  about_title_en: 'Every Candle is a Work of Art',
  about_body_fa: 'کیوت کندل با باور به اینکه هر لحظه‌ای می‌تواند جادویی باشد...',
  about_body_en: 'Cute Candels believes every moment can be magical...',
  about_body2_fa: 'هر شمع با عشق و دقت ساخته می‌شود...',
  about_body2_en: 'Every candle is made with love and precision...',
  telegram_id: '@cutecandels',
  eitaa_id: '@cutecandels',
  working_hours_fa: '۹ صبح تا ۱۰ شب',
  working_hours_en: '9 AM to 10 PM',
  delivery_time_fa: '۱ تا ۲ هفته کاری',
  delivery_time_en: '1 to 2 working weeks',
  preparation_time_fa: 'حداقل ۷ روز آماده‌سازی',
  preparation_time_en: 'Minimum 7 days preparation',
  footer_text_fa: 'هنر شمع‌سازی دست‌ساز',
  footer_text_en: 'The Art of Handmade Candles',
  copyright_year: '۱۴۰۴',
  developer_label_fa: 'توسعه دهنده وبسایت',
  developer_label_en: 'Website Developer',
  developer_name: 'فرهاد عبدی',
  developer_url: 'https://www.abdifarhad.ir/',
};

export function SiteConfigProvider({ children }) {
  const { data: config, isLoading } = useQuery(
    'siteConfig',
    fetchSiteConfig,
    {
      staleTime: 1000 * 60 * 10, // 10 min
      retry: 2,
      placeholderData: DEFAULT_CONFIG,
    }
  );

  return (
    <SiteConfigContext.Provider value={{ config: config || DEFAULT_CONFIG, isLoading }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  const ctx = useContext(SiteConfigContext);
  if (!ctx) throw new Error('useSiteConfig must be inside SiteConfigProvider');
  return ctx;
}
